var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-slider relative" },
    [
      _c("div", { ref: "controls", staticClass: " controls" }, [
        _c(
          "div",
          {
            staticClass:
              "bg-black w-[30px] lg:h-[61px] h-[30px] lg:w-[61px] flex items-center justify-center control left-[30px] lg:left-[60px]"
          },
          [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.svg("arrow-left", "h-[10px] stroke-white")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "bg-black w-[30px] lg:h-[61px] h-[30px] lg:w-[61px] flex items-center justify-center control right-[30px] lg:right-[60px]"
          },
          [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.svg("arrow-right", "h-[10px] stroke-white")
                )
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "slider",
          staticClass: "bg-red xl:bg-none flex items-center justify-center"
        },
        _vm._l(_vm.images, function(image, key) {
          return _c(
            "div",
            {
              key: image.id,
              staticClass:
                "h-[300px] md:h-[560px] xl:h-[700px] w-full rounded-8"
            },
            [
              _c("img", {
                staticClass:
                  "h-full cursor-pointer block m-auto rounded-8 object-contain lazyload",
                class:
                  _vm.getHeight(image.url) <= 3000 &&
                  _vm.getHeight(image.url) !== 0
                    ? "w-auto"
                    : "w-auto",
                attrs: { "data-src": image.url, alt: image.name },
                on: {
                  click: function($event) {
                    _vm.index = key
                  }
                }
              })
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("vue-gallery-slideshow", {
        attrs: { images: _vm.images, index: _vm.index },
        on: {
          close: function($event) {
            _vm.index = null
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }